
export const ClosedTradesData = [
    {
        id: 1,
        openTime: {
            time: '17:00.00',
            date: '29 Nov 2021'
        },
        type: 'Sell',
        size: 1,
        symbol: 'xuavand.mic',
        open: 1852.50,
        sl: 0,
        tp: 0,
        pnl: 3.08,
        closeTime: {
            time: '17:00.00',
            date: '29 Nov 2021'
        },
        close: 1234,
        duration: '3 h 40 min',
        commission: '-4.04',
        profit: '-',
        order: 12345678,
        swap: '-0.04',
        tax: 0
    },
    {
        id: 2,
        openTime: {
            time: '17:00.00',
            date: '29 Nov 2021'
        },
        type: 'Sell',
        size: 1,
        symbol: 'xuavand.mic',
        open: 1852.50,
        sl: 0,
        tp: 0,
        pnl: 3.08,
        closeTime: {
            time: '17:00.00',
            date: '29 Nov 2021'
        },
        close: 1234,
        duration: '3 h 40 min',
        commission: '-4.04',
        profit: '-',
        order: 12345678,
        swap: '-0.04',
        tax: 0
    },
    {
        id: 3,
        openTime: {
            time: '17:00.00',
            date: '29 Nov 2021'
        },
        type: 'Sell',
        size: 1,
        symbol: 'xuavand.mic',
        open: 1852.50,
        sl: 0,
        tp: 0,
        pnl: 3.08,
        closeTime: {
            time: '17:00.00',
            date: '29 Nov 2021'
        },
        close: 1234,
        duration: '3 h 40 min',
        commission: '-4.04',
        profit: '-',
        order: 12345678,
        swap: '-0.04',
        tax: 0
    },
    {
        id: 5,
        openTime: {
            time: '17:00.00',
            date: '29 Nov 2021'
        },
        type: 'Sell',
        size: 1,
        symbol: 'xuavand.mic',
        open: 1852.50,
        sl: 0,
        tp: 0,
        pnl: 3.08,
        closeTime: {
            time: '17:00.00',
            date: '29 Nov 2021'
        },
        close: 1234,
        duration: '3 h 40 min',
        commission: '-4.04',
        profit: '-',
        order: 12345678,
        swap: '-0.04',
        tax: 0
    },
    {
        id: 6,
        openTime: {
            time: '17:00.00',
            date: '29 Nov 2021'
        },
        type: 'Sell',
        size: 1,
        symbol: 'xuavand.mic',
        open: 1852.50,
        sl: 0,
        tp: 0,
        pnl: 3.08,
        closeTime: {
            time: '17:00.00',
            date: '29 Nov 2021'
        },
        close: 1234,
        duration: '3 h 40 min',
        commission: '-4.04',
        profit: '-',
        order: 12345678,
        swap: '-0.04',
        tax: 0
    },
    {
        id: 7,
        openTime: {
            time: '17:00.00',
            date: '29 Nov 2021'
        },
        type: 'Sell',
        size: 1,
        symbol: 'xuavand.mic',
        open: 1852.50,
        sl: 0,
        tp: 0,
        pnl: 3.08,
        closeTime: {
            time: '17:00.00',
            date: '29 Nov 2021'
        },
        close: 1234,
        duration: '3 h 40 min',
        commission: '-4.04',
        profit: '-',
        order: 12345678,
        swap: '-0.04',
        tax: 0
    },
]